'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      gcLock = _ref.gcLock,
      preload = _ref.preload;

  var get = require('../get')({
    ipld: ipld,
    preload: preload
  });

  var put = require('../put')({
    ipld: ipld,
    gcLock: gcLock,
    preload: preload
  });

  return /*#__PURE__*/function () {
    var _addLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(multihash, link, options) {
      var node;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return get(multihash, options);

            case 2:
              node = _context.sent;
              node.addLink(link);
              return _context.abrupt("return", put(node, options));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function addLink(_x, _x2, _x3) {
      return _addLink.apply(this, arguments);
    }

    return addLink;
  }();
};